import { render, staticRenderFns } from "./Pickls.vue?vue&type=template&id=3ed1a1de&scoped=true&"
import script from "./Pickls.vue?vue&type=script&lang=ts&"
export * from "./Pickls.vue?vue&type=script&lang=ts&"
import style0 from "./Pickls.vue?vue&type=style&index=0&id=3ed1a1de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed1a1de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ed1a1de')) {
      api.createRecord('3ed1a1de', component.options)
    } else {
      api.reload('3ed1a1de', component.options)
    }
    module.hot.accept("./Pickls.vue?vue&type=template&id=3ed1a1de&scoped=true&", function () {
      api.rerender('3ed1a1de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SAdmin/Pickls.vue"
export default component.exports